import { storage } from '../../services/storage/storage.service';

const LOGIN_EMAIL_STORAGE_KEY = 'login-email';
const LOGIN_EMAIL_STORAGE_TTL = 5 * 60 * 1000; // 5min

export const loginStorage = {
  setEmail: (email) => {
    storage.setItem(
      LOGIN_EMAIL_STORAGE_KEY,
      JSON.stringify({
        email,
        createdAt: new Date().toISOString(),
      }),
    );
  },
  getEmail: () => {
    const item = storage.getItem(LOGIN_EMAIL_STORAGE_KEY);

    const { email, createdAt } = JSON.parse(item || '{}');

    const isExpired = Date.now() - Date.parse(createdAt) > LOGIN_EMAIL_STORAGE_TTL;

    if (!email || isExpired) {
      loginStorage.removeEmail();
    } else {
      return email;
    }
  },
  removeEmail: () => {
    storage.removeItem(LOGIN_EMAIL_STORAGE_KEY);
  },
};
